/** basic.linkRules */
export default {
    link_trigger: "Устройство-триггер",
    link_triggerPla: "Введите полный код устройства-триггера",
    link_linkage: "Связанное устройство",
    link_editLinkageTips: "Изменить состояние (вкл/выкл) правила связи?",
    link_dialogTitel: "Правила связи устройств",

    message_openDetailsLose: "Не удалось открыть детали",
    message_delectSucc: "Удалено!",
    message_delectLose: "Не удалось удалить",

    add_triggerCondition: "Условия срабатывания",
    add_triggerConditionTips: "Очистить условия срабатывания?",
    add_deviceCoding: "Код устройства",
    add_eventType: "Тип события",
    add_isOpen: "Включено",
    add_clearLinkageTips: "Очистить связанное устройство?",
    add_executeMOvement: "Действие выполнения",
    add_executeMOvementTips: "Очистить действие выполнения?",
    add_devcieOrder: "Команда устройства",
    add_saveLink: "Сохранить правило",
    add_setTrigger: "Настроить условия срабатывания",
    add_setLinkage: "Настроить связанное устройство",
    add_triggerEvent: "Событие-триггер",
    add_select: "Выбрать",
    add_linakageCommand: "Команда связанного устройства",
    add_deviceModelNum: "Модель устройства",

    message_selectTrigger: "Выберите устройство-триггер!",
    message_triggerEvent: "Выберите тип события-триггера!",
    message_lingkaeDevice: "Выберите связанное устройство!",
    message_lingkaeCommand: "Выберите команду для выполнения связи!",
    link_deleteTips: "Удалить это правило связи?",
}

